// extracted by mini-css-extract-plugin
module.exports = {"pasteFailToastContent":"style_pasteFailToastContent__314k4","pasteFailToast":"style_pasteFailToast__2az4x"};